import React from 'react';
import { useFormikContext } from 'formik';
import { Button } from '@/shared/ui/elements';
import { label } from '@/shared/ui/core';

export default ({
  forEdit,
  slick,
  type = 'button',
  noEditLabel = 'Next',
}) => {
  const { isSubmitting, handleSubmit } = useFormikContext();

  const buttonLabel = !forEdit ? noEditLabel : 'Save';

  return (
    <Button
      disabled={isSubmitting}
      type={type}
      modifiers={['primary', `${isSubmitting ? 'loading' : ''}`]}
      onClick={!forEdit ? () => slick?.current?.slickNext() : handleSubmit}
      {...label(buttonLabel)}
    >
      {buttonLabel}
    </Button>
  );
};
